




















































































































import Vue from "vue";

export default Vue.extend({
    props: {
        picture: {
            type: Object,
            required: true
        },
        isFirst: {
            type: Boolean,
            required: true
        },
        isLast: {
            type: Boolean,
            required: true
        },
        isAboveLimit: {
            type: Boolean,
            required: true
        }
    },

    data: function() {
        return {
            isFocus: false as boolean
        };
    },

    methods: {
        moveLeft: function() {
            this.$emit("move-left", this.picture);
        },
        moveRight: function() {
            this.$emit("move-right", this.picture);
        },
        edit: function() {
            this.$store.commit("ModalModule/openPictureModal", this.picture);
        }
    }
});

